import { useEffect } from "react";
import { archivedAnalyzeTarget } from "@/shared/lib/archivedAnalyzeRoutes";

/** Replace (not push) a retired Analyze URL, so Back does not bounce into it. */
export function ArchivedAnalyzeRedirect() {
  useEffect(() => {
    const target = archivedAnalyzeTarget(window.location.pathname) ?? "/";
    window.history.replaceState({}, "", target);
    window.dispatchEvent(new PopStateEvent("popstate"));
  }, []);
  return null;
}
